import { Link } from "react-router-dom";
import { Facebook, Instagram, Phone, Mail, MapPin } from "lucide-react";
import { COMPANY } from "../data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0A221C] text-[#FDFBF7] relative overflow-hidden">
    <div className="grain" />
    <div className="ll-container relative py-20">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <span className="inline-block bg-white rounded-xl px-4 py-3">
            <img src={COMPANY.logo} alt="Life Line Tours and Travels Pvt Ltd" className="h-14 w-auto object-contain" />
          </span>
          <p className="text-[#FDFBF7]/70 mt-5 max-w-xs leading-relaxed">
            {COMPANY.tagline}. A trusted family-run travel house serving India and the world since 1991.
          </p>
          <div className="flex gap-3 mt-6">
            <a href={COMPANY.social.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#4ef72d] hover:text-[#0A221C] hover:border-[#4ef72d] transition-all">
              <Facebook size={18} />
            </a>
            <a href={COMPANY.social.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#4ef72d] hover:text-[#0A221C] hover:border-[#4ef72d] transition-all">
              <Instagram size={18} />
            </a>
          </div>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-sm uppercase tracking-widest text-[#f7ad2d] mb-5 font-semibold">Explore</h4>
          <ul className="space-y-3 text-[#FDFBF7]/75 text-sm">
            <li><Link to="/domestic-tours" className="hover:text-[#4ef72d]">Domestic Tours</Link></li>
            <li><Link to="/international-tours" className="hover:text-[#4ef72d]">International Tours</Link></li>
            <li><Link to="/mice-events" className="hover:text-[#4ef72d]">MICE & Events</Link></li>
            <li><Link to="/farmers-study-tours" className="hover:text-[#4ef72d]">Farmers&apos; Study Tours</Link></li>
            <li><Link to="/blog" className="hover:text-[#4ef72d]">Travel Stories</Link></li>
            <li><Link to="/about" className="hover:text-[#4ef72d]">About Us</Link></li>
            <li><Link to="/faq" className="hover:text-[#4ef72d]">FAQ</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-sm uppercase tracking-widest text-[#f7ad2d] mb-5 font-semibold">Contact</h4>
          <ul className="space-y-4 text-[#FDFBF7]/75 text-sm">
            <li className="flex gap-3"><Phone size={18} className="text-[#4ef72d] shrink-0" />
              <span>{COMPANY.phones.map((p) => (<a key={p} href={`tel:${p.replace(/\s/g, "")}`} className="block hover:text-[#4ef72d]">{p}</a>))}</span>
            </li>
            <li className="flex gap-3"><Mail size={18} className="text-[#4ef72d] shrink-0" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-[#4ef72d] break-all">{COMPANY.email}</a>
            </li>
            <li className="flex gap-3"><MapPin size={18} className="text-[#4ef72d] shrink-0" /><span>{COMPANY.address}</span></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-sm uppercase tracking-widest text-[#f7ad2d] mb-5 font-semibold">Find Us</h4>
          <div className="rounded-2xl overflow-hidden border border-white/10 h-40">
            <iframe title="Life Line Office Map" src={COMPANY.mapEmbed} width="100%" height="100%" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 mt-14 pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#FDFBF7]/50">
        <p>© {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.</p>
        <p>Ministry of Tourism • Incredible India • ETAA Member</p>
      </div>
    </div>
  </footer>
);
